import {connect} from "react-redux";
import UCDListing from "./List";
import {bindActionCreators} from "redux";
import {ucdList} from "../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    ucdListResponse:state.Dealer.ucdList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ucdList
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UCDListing);
